import MediaService from "./../../../services/MediaService";

export default {
  namespaced: true,
  state: () => ({
    mediaList: [],
  }),
  getters: {},
  mutations: {
    setMediaList: (state, data) => {
      state.mediaList = data;
    },
  },
  actions: {
    getMediaList: ({ commit }, media) => {
      return new Promise((resolve, reject) => {
        commit("setMediaList", []);
        MediaService.mediaList(media)
          .then((res) => {
            if (res.status === 200) {
              commit("setMediaList", res.data);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getMediaListLimit: ({ state, commit }, media) => {
      return new Promise((resolve, reject) => {
        MediaService.mediaList(media)
          .then((res) => {
            if (res.status === 200) {
              commit("setMediaList", state.mediaList.concat(res.data));
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    searchMedia: ({ commit }, searchData) => {
      return new Promise((resolve, reject) => {
        commit("setMediaList", []);
        MediaService.searchMedia(searchData)
          .then((res) => {
            if (res.status === 200) {
              commit("setMediaList", res.data);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
